<template>
  <div>
    <div
      class="overlay"
      @click="hideMenus"
      v-show="
        this.$store.state.show_event_list ||
        this.$store.state.usermenu_is_visible
      "
    ></div>
    <section
      id="header"
      ref="header"
      :class="[
        event_selected ? 'is_event e' + event_selected.type_id : '',
        environment,
        $mq,
      ]"
    >
      <div id="event" :class="{ active: event_selected }">
        <div
          @click="toogleEventHome('/')"
          v-if="event_selected"
          class="event_active"
        >
          <img src="/img/logo_new_short.png" />
        </div>
        <img
          style="float: left"
          @click="toogleHome"
          v-else
          src="/img/logo_new_short.png"
        />
        <div class="current-event">
          <div @click="toggleEventList" class="event_expand"></div>
          <div class="event-name" v-if="event_active.name">
            {{ event_active.name }}
          </div>
          <div class="event-name" v-else>Selecciona un esdeveniment</div>
        </div>
      </div>

      <div id="menu-container" ref="menucontainer">
        <Menu :headerWidth="headerWidth"></Menu>
      </div>

      <div class="event-list" v-show="this.$store.state.show_event_list">
        <!-- <router-link v-if="event_selected"  :to="home" class="home"><img src="/img/logo_new.png" />{{ $t( 'init' ) }}</router-link> -->
        <div v-if="false" @click="changeEvent($event, '/')" class="item">
          <div>
            <img class="img2" src="/img/logo_new.png" />
            <div class="content2">{{ $t("init") }}</div>
          </div>
        </div>
        <div
          v-for="(item, index) in events_active"
          @click="changeEvent($event, item.url)"
          :class="'item e' + item.type"
        >
          <div>
            <img class="img" :src="item.img" />
            <div class="content">{{ $t(item.name) }}</div>
          </div>
        </div>
      </div>

      <div class="user-box">
        <img class="avatar" :src="user.avatar" @click="toggleUserMenu" />
        <div class="selectable" v-show="this.$store.state.usermenu_is_visible">
          <div class="list">
            <div class="item no-pointer">{{ user.name }}</div>
            <!-- <div @click="profile(user.id)" class="item">{{ 'account' | i18n }}</div> -->
            <div @click="logout()" class="item">{{ "logout" | i18n }}</div>
          </div>
        </div>
      </div>

      <Searcher></Searcher>
    </section>
    <div
      :class="{
        separator: !this.$store.state.topbar_actions_visible,
        mix_separator: this.$store.state.topbar_actions_visible,
        full_separator: full_separator,
      }"
    ></div>
  </div>
</template>

<script>
import { Api } from "@/core/api.js";

import Topbar from "@/components/ui/Topbar";
import Searcher from "@/components/ui/Searcher";
import Menu from "@/components/layout/Menu";
import i18n from "@/i18n";
const api = new Api();

export default {
  components: { Menu, Topbar, Searcher },
  data() {
    return {
      home: "/",
      // page: ROUTER[ this.$store.state.current_page ].label,
      actions: {
        main: { label: "Asignar jugador", url: "/" },
        other: [
          { label: "Exportar", url: "/" },
          { label: "Filtrar", url: "/" },
        ],
      },
      searcher: {
        placeholder: "Buscar...",
      },
      display_locations: false,
      location_search: "",
      region: 0,
      type: 0,
      path: "",
      environment: process.env.VUE_APP_ENVIRONMENT,
      headerWidth: 1500,
    };
  },
  computed: {
    user() {
      return this.$store.getters["user/getUser"];
    },

    event_active() {
      var oEvent = { ...this.$store.getters["events/getCurrentEvent"]() };
      oEvent.img = "http://intranet.micfootball.com/upload/eventos/1_2954.png";
      oEvent.url =
        typeof oEvent.name !== "undefined" &&
        typeof oEvent.edition !== "undefined"
          ? this.$root.formatEventUrl(oEvent.name, oEvent.edition)
          : "";
      oEvent.name =
        typeof oEvent.name !== "undefined" &&
        typeof oEvent.edition !== "undefined"
          ? this.$root.formatEventName(oEvent.name, oEvent.edition)
          : "";

      return oEvent;
    },

    event_selected() {
      return this.$store.getters.isEventSelected
        ? this.$store.getters["events/getCurrentEvent"]()
        : false;
    },

    breadcrumbs() {
      var sCurrentPage = this.$store.state.current_page;
      var aBreadCrumbs = [];
      var bEnd = false;

      while (!bEnd) {
        aBreadCrumbs.push(ROUTER[sCurrentPage]);
        if (ROUTER[sCurrentPage].parent_id == -1) {
          bEnd = true;
        }

        sCurrentPage = ROUTER[sCurrentPage].parent_id;
      }

      return aBreadCrumbs.reverse();
    },

    page() {
      return ROUTER[this.$store.state.current_page].label;
    },

    events_active() {
      var aEvents = this.$store.getters["events/getActives"]();
      var aResult = [];
      var self = this;
      aEvents.forEach((event) => {
        // if( !this.event_selected || this.event_active.id != event.id ){
        aResult.push({
          url: self.$root.formatEventUrl(event.name, event.edition),
          name: self.$root.formatEventName(event.name, event.edition),
          img: event.logo,
          type: event.type_id,
        });
        // }
      });
      // return [
      // 	{url: '/', name: 'MIC Football 2020', img: 'http://intranet.micfootball.com/upload/eventos/1_2954.png' },
      // 	{url: '/', name: 'Nike Camp 2019', img: 'https://nikecamp.es/wp-content/uploads/2018/10/nike_camp-3.png' },
      // ];
      return aResult;
    },
    full_separator() {
      return (
        this.$store.getters.getTopbarActionsVisible() &&
        this.$store.getters.getTopFiltersVisible()
      );
    },
  },
  methods: {
    toggleMenu() {
      this.$store.commit("setMenuVisible", !this.$store.state.menu_is_visible);
    },
    toggleEventList() {
      this.$store.commit(
        "setEventListVisible",
        !this.$store.state.show_event_list
      );
    },
    toogleEventHome(url) {
      this.$router.push(url);
    },
    toogleHome() {
      this.$router.push({ name: "home" });
    },
    hideMenus() {
      this.$store.commit("setUserMenuVisible", false);
      this.$store.commit("setEventListVisible", false);
    },
    toggleLocations() {
      if (this.display_locations) {
        this.display_locations = false;
        // this.$store.commit('setOverlayVisible', false);
        // this.$overlay.hide();
      } else {
        this.display_locations = true;
        // this.$overlay.show();
        // this.$store.commit('setOverlayVisible', true);
      }
    },
    toggleUserMenu() {
      if (this.$store.state.usermenu_is_visible) {
        this.$store.commit("setUserMenuVisible", false);
      } else {
        this.$store.commit("setUserMenuVisible", true);
      }
    },
    select(location) {
      var self = this;
      this.$store
        .dispatch("locations/pushFavLocation", location)
        .then(function () {
          self.$store.commit("locations/setSelectedLocation", location);
          self.toggleLocations();
          self.location_search = "";
        });
    },

    profile(id) {
      this.$router.replace({ name: "user_card", params: { id: id } });
    },

    logout() {
      var self = this;
      api.get("logout").then(function (data) {
        self.$store.commit("user/setAuthenticate", false);
        self.$store.commit("setOverlayVisible", false);
        self.$store.commit("setUserMenuVisible", false);
        localStorage.removeItem("redirect");
        self.$router.replace({ name: "login" });
      });
    },

    changeEvent(e, url) {
      this.$store.commit(
        "setEventListVisible",
        !this.$store.state.show_event_list
      );
      if (url != this.$router.currentRoute.path) {
        this.$overlay.loading();

        this.$router.push(url);
        this.$store.commit("setEventSelected", false);
        // var self = this
        // this.$store.dispatch( 'events/loadByName', this.$route.params.event ).then( function(){
        // 	self.$overlay.hide()
        // });
      }
    },

    getDimensions() {
      if (this.$refs.header != undefined) {
        this.headerWidth = this.$refs.header.clientWidth;
      } else this.headerWidth = window.innerWidth;
    },
  },
  created() {
    var self = this;
    window.addEventListener("resize", this.getDimensions);
    /* api.post('login', {'username': 'GT500', 'password': '0ffe1abd1a08215353c233d6e009613e95eec4253832a761af28ff37ac5a150c' })
    .then(function(response){
    	console.log(response);
    	self.location.name = response;
    }) */

    /* api.get('labels')
    .then(function(response){
    	console.log(response);
    	self.location.name = response;
    }) */
  },
  updated: function () {
    if (this.$refs.header != undefined) {
      this.headerWidth = this.$refs.header.clientWidth;
    } else this.headerWidth = window.innerWidth;
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.no-pointer {
  cursor: default !important;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: red;
  z-index: $z-header;
  opacity: 0;
}
#header {
  width: 100%;
  height: $header-height;
  position: fixed;
  overflow: inherit;
  left: 0;
  top: 0;
  border-bottom: 1px solid #ddd;
  z-index: $z-header;
  background: $dark-color;

  &.development {
    top: $height-development;
  }
  &.is_event {
    background: $main-color;

    &.e1 {
      background-color: $main-color-e1;
    }
    &.e2 {
      background-color: $main-color-e2;
    }
    &.e3 {
      background-color: $main-color-e3;
    }
    &.e4,
    &.e12 {
      background-color: $main-color-e4;
    }
    &.e5 {
      background-color: $main-color-e5;
    }
    &.e13 {
      background-color: $main-color-e13;
    }
    &.e14 {
      background-color: $main-color-e14;
    }
    &.e15 {
      background-color: $main-color-e15;
    }
    &.e16 {
      background-color: $main-color-e16;
    }
    &.e17 {
      background-color: $main-color-e17;
    }
  }

  #event {
    background: inherit;
    overflow: hidden;
    float: left;
    padding: 10px 20px 10px 10px;
    height: $header-height;
    margin-top: -1px;
    cursor: pointer;
    // background: url('/img/down_w.svg') no-repeat right 10px center;
    // background-size: 10px;
    width: calc(160px + 300px);

    &.active {
    }

    .title {
      color: #fff;
      margin: 0;
      font-size: 16px;
    }

    img {
      width: auto;
      object-fit: contain;
      object-position: center;
      height: 100%;
    }

    .event_active {
      width: 150px;
      height: 100%;
      float: left;

      img {
        height: 100%;
        width: auto;
        object-fit: initial;
        object-position: initial;
        float: left;
        display: inline-block;
      }

      .content {
        float: left;
        color: #fff;
        display: inline-block;
        line-height: 45px;
        font-size: 14px;
        margin-left: 10px;
      }
    }

    .current-event {
      border: 1px solid white;
      border-radius: 5px;
      float: right;
      width: 250px;
      display: inline-block;

      .event-name {
        float: right;
        color: #fff;
        width: 200px;
        display: inline-block;
        line-height: 45px;
        font-size: 15px;
        margin: 0 10px;
      }

      .event_expand {
        content: "";
        background: url(/img/down_w.svg);
        background-size: 12px;
        background-repeat: no-repeat;
        width: 25px;
        height: 100%;
        float: right;
        background-position: center;
        cursor: pointer;
        margin-left: 3px;

        background-color: rgba(255, 255, 255, 0.25);
        height: 45px;
        border-radius: 3px;
      }
    }
  }

  .event-list {
    position: fixed;
    top: 85px;
    background: #eee;
    z-index: 15;
    left: 190px;
    padding: 10px 0;
    width: 250px;

    .home {
      width: 100%;
      height: 35px;
      text-align: center;
      float: left;
      width: 100%;

      img {
        height: 25px;
        width: auto;
      }
    }

    .item {
      padding: 10px 10px;
      text-align: left;
      color: #333;
      font-size: 14px;
      overflow: hidden;
      opacity: 0.8;
      margin: 5px 0;
      cursor: pointer;
      border-left: 15px solid #222;
      width: 100%;

      &.e1 {
        border-left: 15px solid $main-color-lighter-e1;
      }
      &.e2 {
        border-left: 15px solid $main-color-lighter-e2;
      }
      &.e3 {
        border-left: 15px solid $main-color-lighter-e3;
      }
      &.e4,
      &.e12 {
        border-left: 15px solid $main-color-lighter-e4;
      }
      &.e5 {
        border-left: 15px solid $main-color-lighter-e5;
      }
      &.e13 {
        border-left: 15px solid $main-color-lighter-e13;
      }
      &.e14 {
        border-left: 15px solid $main-color-lighter-e14;
      }
      &.e15 {
        border-left: 15px solid $main-color-lighter-e15;
      }
      &.e16 {
        border-left: 15px solid $main-color-lighter-e16;
      }
      &.e17 {
        border-left: 15px solid $main-color-lighter-e17;
      }

      .img {
        width: 30px;
        height: 20px;
        display: inline-block;
        float: left;
        cursor: pointer;
        display: none;
      }
      .img2 {
        width: 70px;
        height: 20px;
        display: inline-block;
        float: left;
        cursor: pointer;
        display: none;
      }
      .content {
        display: inline-block;
        float: left;
        width: calc(100%);
        color: #333;
        padding-left: 5px;
        cursor: pointer;
      }
      .content2 {
        display: inline-block;
        float: left;
        width: calc(100% - 30px);
        color: #333;
        padding-left: 5px;
        cursor: pointer;
      }
      &:hover {
        opacity: 1;
      }
    }
  }

  #logo {
    width: 25%;
    max-width: 250px;
    float: left;
    height: $header-height;
    padding: 5px 10px;

    img {
      width: auto;
      object-fit: contain;
      object-position: center;
      height: 100%;
    }
  }

  #searcher {
    float: right;
    padding: 9px;
    margin-left: 10px;

    .input {
      background: #fff;
      height: 45px;
      overflow: hidden;
      border-radius: 3px;

      .icon {
        width: 55px;
        height: 45px;
        padding: 12px 15px 12px 5px;
        background: #ccc;
        display: inline-block;
        float: left;
        background: url("/img/down.svg") no-repeat right 5px center;
        background-size: 10px;
        border-right: 0px solid #ddd;
        background-color: #fff;
        cursor: pointer;
      }
      input {
        height: 50px;
        width: 250px;
        border: none;
        display: inline-block;
        float: left;
        padding: 10px;
        outline: none;
        background: #e3e5f3;
      }
    }
  }

  #menu-container {
    float: left;
    max-height: 50px;
  }

  .logo {
    height: $header-height;
    cursor: pointer;
    position: absolute;
    left: 0;
    top: 0;

    img {
      height: 100%;
    }
  }

  .menu {
    float: left;
    background: url("~@/assets/img/menu.svg") no-repeat center;
    width: 25px;
    height: 25px;
    cursor: pointer;
    margin-left: 120px;
    margin-top: 12.5px;
  }
  .title {
    float: left;
    font-size: 14pt;
    margin-left: 15px;
    margin-top: 12.5px;
  }

  .user-box {
    display: inline-block;
    float: right;
    border-radius: 3px;
    overflow: hidden;
    z-index: 12;
    padding: 10px;
    cursor: pointer;

    .avatar {
      border-radius: 100%;
      height: 40px;
      margin: 0 5px;
    }
    .selectable {
      background: #eee;
      position: fixed;
      top: 82px;
      right: 0;
      z-index: 51;

      .list {
        padding: 10px 5px;

        .item {
          text-align: left;
          overflow: hidden;
          padding: 10px 10px;
          cursor: pointer;
          font-size: 10pt;
          color: #333;
          text-decoration: none;
          display: block;
        }
      }
    }
  }
}

#topbar {
  height: $topbar-height;
  width: 100%;
  top: $header-height;
  position: fixed;
  overflow: hidden;
  padding: 0 10px;
  background-color: $bg-color;
  border-bottom: 1px solid #ddd;

  .title {
    float: left;
    font-size: 16px;
    font-weight: bold;
    text-transform: uppercase;
    margin-right: 10px;
    padding: 20px 10px;
    color: #0d122d;
  }

  #breadcrumbs {
    display: inline-block;
    float: left;

    .item {
      float: left;
      margin: 0 10px;
      height: 50px;
      padding: 20px 5px;
      font-size: 14px;
      cursor: pointer;

      &:hover {
        border-bottom: 3px solid #0d122d;
      }

      .name {
        text-decoration: none;
        color: #333;
      }
    }
  }

  #actions {
    float: right;
    padding: 5px;

    .item {
      padding: 15px;
      display: inline-block;
      float: left;

      &#main {
        height: 35px;
        padding: 8px 20px;
        padding-left: 35px;
        text-align: center;
        margin-right: 15px;
        border-radius: 3px;
        font-size: 12px;
        text-transform: uppercase;
        color: #fff;
        cursor: pointer;
        background: url("/img/add.svg") no-repeat left 10px center #8bc34a;
        background-size: 15px;

        &:hover {
          background-color: #5ea740;
        }
      }
      &.more {
        background: url("/img/menu_b.svg") no-repeat center;
        background-size: 25px;
        border: 1px solid #ccc;
        padding: 10px;
        height: 35px;
        width: 50px;
        background-color: #fff;
        cursor: pointer;
        border-radius: 3px;
      }
    }
  }
}

.separator {
  width: 100%;
  height: 60px;
}
.mix_separator {
  width: 100%;
  height: 110px;
}
.full_separator {
  width: 100%;
  height: 160px;
}

#header.portrait {
  #event {
    width: auto;
    .event_active {
      width: 60px;
      height: auto;
      padding: 12.5px 0;
    }
    .current-event {
      display: none;
    }
  }
  #searcher {
    display: none;
    .input {
      input {
      }
    }
  }
}
</style>
